import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import Home from "./user/pages/Home";
import About from "./user/pages/About";
import Category from "./user/pages/Category";
import Blog from "./user/pages/Blog";
import AllBlogs from "./user/pages/AllBlogs";
import Contact from "./user/pages/Contact";
import UserLogin from "./user/pages/UserLogin";
import UserSignup from "./user/pages/UserSignup";
import MyBlogs from "./user/pages/MyBlogs";
import CreateBlogs from "./user/pages/CreateBlogs";
import Product from "./user/pages/Product";
import ProductSlug from "./user/pages/ProductSlug";
import Checkout from "./user/pages/Checkout";
import AccountOrder from "./user/pages/account/AccountOrder";
import AccountOrderView from "./user/pages/account/AccountOrderView";
import Accountprofile from "./user/pages/account/Accountprofile";
import AccountPassword from "./user/pages/account/AccountPassword";
import AccountSupport from "./user/pages/account/AccountSupport";
import AccountPlan from "./user/pages/account/AccountPlan";
import Account from "./user/pages/account/Account";
import AccountAllEnquire from "./user/pages/account/AccountAllEnquire";
import AccountAllTransactions from "./user/pages/account/AccountAllTransactions";
import CartPage from "./user/pages/Cart";
import CompleteOrder from "./user/pages/CompleteOrder";
import WishList from "./user/pages/WishList";
import Comparsion from "./user/pages/Comparsion";
import Page from "./user/pages/Page";
import Cancel from "./user/pages/Cancel";
import SignupUserType from "./user/pages/SignupUserType";

import ErrorPage from "./user/pages/ErrorPage";

import { Toaster } from "react-hot-toast";

import { BlogProvider } from "./fetchdata/BlogContext";

import usePreventZoom from "./helper/usePreventZoom";
import getCookie from "./helper/getCookie";
import AllVendors from "./user/pages/vendor/AllVendors";
import ViewVendor from "./user/pages/vendor/ViewVendor";
import getDecryptData from "./helper/getDecryptData";
import AllPlans from "./user/pages/vendor/AllPlans";
import CheckoutPlan from "./user/pages/CheckoutPlan";
import CardView from "./user/pages/CardView";
import SuccessPage from "./user/pages/vendor/SuccessPage";
import FailPage from "./user/pages/vendor/FailPage";
import AccountprofileNew from "./user/pages/account/AccountprofileNew";
import AccountAllOrder from "./user/pages/account/AccountAllOrder";
import AccountAllMedical from "./user/pages/account/AccountAllMedical";
import AccountAllVideoCall from "./user/pages/account/AccountAllVideoCall";
import AccountVideoCall from "./user/pages/account/AccountVideoCall";
import AccountMedicalView from "./user/pages/account/AccountMedicalView";
import AllHospital from "./user/pages/vendor/AllHospital";
import ViewHospital from "./user/pages/vendor/ViewHospital";
import TestingHome from "./user/pages/testing/TestingHome";
import TestingDoctorList from "./user/pages/testing/TestingDoctorList";
import TestingHospitalList from "./user/pages/testing/TestingHospitalList";
import TestingHospitalView from "./user/pages/testing/TestingHospitalView";
import AccountBookingView from "./user/pages/account/AccountBookingView";

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

function App() {


  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        setisUsertype(mydatatype);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

  return (
    <>
      <BlogProvider>
        <Toaster />

        <Routes>

 <Route path="/" element={<Home />} />
 <Route path="/doctor-list" element={<TestingDoctorList />} />
 <Route path="/clinic-list" element={<TestingHospitalList />} />
 <Route path="/hospital-view" element={<TestingHospitalView />} />
 <Route path="/all-clinic" element={<AllHospital />} />
 <Route path="/all-doctor" element={<AllVendors />} />
 <Route path="/clinic/:id" element={<ViewHospital />} />
  <Route path="/doctor/:id" element={<ViewVendor updateAuthStatus={setIsUserAuthenticated} />} />
    <Route
            path="/login"
            element={isUserAuthenticated ? <Account /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} /> }
          />

    <Route
            path="/account"
            element={
              isUserAuthenticated ? <Account /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
            }
          />
          <Route
            path="/account/order/:userId/:orderId"
            element={
              isUserAuthenticated ? (
                <AccountOrderView />
              ) : (
            <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />

          <Route path="/account/plan"
            element={
              isUserAuthenticated ? (
                <AccountPlan />
              ) : (
              <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )

            }
          />


          <Route
            path="/account/profile"
            element={
              isUserAuthenticated ? (
                <Accountprofile />
              ) : (
              <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />

          <Route
            path="/account/profile-kyc"
            element={
              isUserAuthenticated ? (
                <AccountprofileNew />
              ) : (
         <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />




          <Route
            path="/account/password"
            element={
              isUserAuthenticated ? (
                <AccountPassword />
              ) : (
            <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />
          <Route
            path="/account/support"
            element={
              isUserAuthenticated ? (
                <AccountSupport />
              ) : (
          <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />
          <Route
            path="/account/all-enquire"
            element={
              isUserAuthenticated ? (
                <AccountAllEnquire />
              ) : (
               <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />
          <Route
            path="/account/all-transactions"
            element={
              isUserAuthenticated ? (
                <AccountAllTransactions />
              ) : (
             <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />
  <Route
            path="/account/all-order"
            element={
              isUserAuthenticated ? (
                <AccountAllOrder />
              ) : (
              <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />


             <Route
            path="/account/booking/:orderId"
            element={
              isUserAuthenticated ? (
                <AccountBookingView />
              ) : (
                 <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />

 
  <Route
            path="/account/all-medical"
            element={
              isUserAuthenticated ? (
                <AccountAllMedical />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
              )
            }
          />

 <Route
            path="/login"
            element={    isUserAuthenticated ? <Account /> :<UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
          }
          />

       <Route path="page/:slug" element={<Page />} />
 
    <Route path="/:id" element={<Category />} />
          <Route path="/product/:slug/" element={<ProductSlug />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/allblogs" element={<AllBlogs />} />
       <Route path="/404" element={<ErrorPage />} />

      <Route path="/complete-order" element={isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />} />

          <Route path="/blog/:slug" element={<Blog />} />

{/* 
          <Route path="/about" element={<About />} />

          <Route
            path="/login"
            element={<UserLogin updateAuthStatus={setIsUserAuthenticated} />}
          />
          <Route path="/signup" element={<UserSignup />} />

          <Route path="/product/:id" element={<Product />} />

          <Route
            path="/checkout"
            element={<Checkout updateAuthStatus={setIsUserAuthenticated} />}
          />
          <Route path="/cart" element={<CartPage />} />

          <Route path="/complete-order" element={<CompleteOrder />} />

          <Route
            path="/wishList"
            element={
              isUserAuthenticated ? <WishList /> : <Navigate to="/login" />
            }
          />

          <Route
            path="/comparsion"
            element={
              isUserAuthenticated ? <Comparsion /> : <Navigate to="/login" />
            }
          />

      
 <Route
            path="/account/all-video-call"
            element={
              isUserAuthenticated ? (
                <AccountAllVideoCall />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
           <Route
            path="/video-call"
            element={
              isUserAuthenticated ? (
                <AccountVideoCall />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          
               <Route
            path="/account/medical/:orderId"
            element={
              isUserAuthenticated ? (
                <AccountMedicalView />
              ) : (
                <Navigate to="/login" />
              )
            }
          />



          <Route path="/cancel" element={<Cancel />} />

          <Route path="/" element={<Home />} />

       

          <Route path="/signup-user" element={<SignupUserType />} />
 
          
          <Route path="/doctor/:id" element={<ViewVendor updateAuthStatus={setIsUserAuthenticated} />} /> 

          <Route path="/checkout-plan/:id" element={<CheckoutPlan />} />
          <Route path="/card-view/:id" element={<CardView />} />


          <Route path="/all-plan" element={<AllPlans />} />
   
       */}
    <Route path="/payment-success/:id" element={<SuccessPage />} />
          <Route path="/payment-fail/" element={<FailPage />} />

          <Route path="*" element={<ErrorPage />} />


        </Routes>
        <ScrollToTop />
      </BlogProvider>
    </>
  );
}

export default App;
